import * as THREE from 'three'
import React, { useMemo } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {    
    const railWidth = 0.2;

    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption == "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture == "none" || params.wainscotTexture == "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const trimPosOffset = useMemo(() => {
        if(params.backLeanStoragePosition > 0 && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - railWidth) return railWidth;
        else return 0;
    }, [params.backLeanStoragePosition, params.leanB_p_d, params.add_storage_back])
   
    const wainscotTrimSideModelObj = useMemo(() => {

        let lengthOffset;
        if(params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) - railWidth) lengthOffset = railWidth / 4;
        else lengthOffset = 0;

        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_back) + lengthOffset + trimPosOffset)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.leanB_p_pos - params.backLeanStoragePosition, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
     
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        /**********************cutting hole using CSG Front************************/

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.position.set((params.leanB_p_d / -2 + 0.08), 3, 0.07);
        meshWainscotTrimModel_Temp.updateMatrixWorld()
    
        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG, new THREE.Matrix4())

        return CSGWainscotTrimModel.geometry;

    }, [params.leanB_p_pos, params.leanB_p_d, trimPosOffset, params.leanB_p_h, params.add_storage_back, params.backLeanStoragePosition, params.add_storage_check_back, const_var.newDoorsArray, params.add_right_back_lean_porch, params.p_b_c_b_b_l, params.add_left_back_lean_porch])

    return (
        <group position={[0, 0, -(params.p_d / 2 + params.leanB_p_w + 0.02 + 0.21)]}>
            {params.p_w_c_n == true &&
                <mesh name="wainscotTrim" geometry={wainscotTrimSideModelObj} >
                    <MaterialWainScotTrimNew   visibleSection={"backLean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel